// extracted by extract-css-chunks-webpack-plugin
module.exports = {"save-modal-title":"_1eGrpb"};